export const sidsListArray = [
  {
    id: 1,
    sidName: 'SID',
    fixOrder: 'TWO',
    fixName: 'FIX IS A NAME',
    country: 'Mexico',
  },
];
